@if ((showErrorMessage || isTouched) && errors?.length) {
    @if (singularError) {
        <small style="font-size: 11px !important;"
               [style.color]="color + '!important'"
               class="text-danger error-message">
            {{ firstError }}<br />
        </small>
    } @else {
        <small translate class="text-danger error-message fs-12" *ngFor="let error of errors">
            {{ error }}<br/>
        </small>
    }
}
